<template>
    <div class="yh-page">
        <el-card>
            <el-collapse v-model="activeNames">
            <el-collapse-item title="基础信息" name="1">
            <el-form ref="form" :model="form" :validate-on-rule-change="false" label-position="right"
                label-width="160px" >
                <div class="container">
                    <div class="left">
                        <el-divider content-position="left">基础信息</el-divider>
                        <!-- <el-col :span="15">
                            <el-form-item label="船舶名">
                                <el-input type="textarea" v-model="form.ship_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col> -->

                        <el-col :span="8">
                            <el-form-item label="创建人">
                                <el-input type="text" v-model="form.creator_name"  disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="申请状态">
                                <el-input type="text" v-model="form.status_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="提交退会时间">
                                <el-input type="text" v-model="form.submit_time" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="18">
                            <el-form-item label="退会成功时间">
                                <el-input type="text" v-model="form.quit_time" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="18">
                            <el-form-item label="所属会员">
                                <el-input type="text" v-model="form.member_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="是否退风险准备金">
                                <el-radio v-model="form.is_account" :label=false :disabled="opera_type !== 'ApplyUpdate'">否</el-radio>
                                <el-radio v-model="form.is_account" :label=true :disabled="opera_type !== 'ApplyUpdate'">是</el-radio>
                                <!-- <el-input type="text" v-model="form.is_account" style="width: 48%;" disabled /> -->
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="退风险准备金金额">
                                <el-input type="number" v-model="form.account" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="业务归属部门" prop="department">
                                <el-select v-model="form.department" placeholder="请选择部门" filterable value-key="id"  style="width: 48%;" >
                                <el-option v-for="g in groupList" :key="g.id"
                                    :label="g.name" :value="g.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="账户名称">
                                <el-input type="text" v-model="form.account_name" style="width: 48%;" :disabled="opera_type !== 'ApplyUpdate'" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="账号">
                                <el-input type="text" v-model="form.account_number" style="width: 48%;" :disabled="opera_type !== 'ApplyUpdate'" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="开户行">
                                <el-input type="text" v-model="form.account_address" style="width: 48%;" :disabled="opera_type !== 'ApplyUpdate'" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="风险准备金发票状态" prop="invoice_type">
                                <el-select v-model="form.invoice_type" placeholder="请选择风险准备金发票状态" filterable value-key="id"  style="width: 48%;" >
                                <el-option v-for="g in invoice_type_list" :key="g.id"
                                    :label="g.name" :value="g.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="退会原因">
                                <el-input type="textarea" :rows="4" v-model="form.quit_reason" style="width: 48%;" :disabled="opera_type !== 'ApplyUpdate'" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="22">
                            <el-form-item label="调差金额">
                                <el-col :span="24">
                                <el-table :key="0" show-summary :data="form.diff_account" stripe fit class="w-100">

                                <el-table-column align="left" label="账户id">
                                    <template slot-scope="scope">
                                    <span>{{scope.row.account_id}}</span>
                                    </template>
                                </el-table-column>


                                
                                <el-table-column align="left" label="账户余额" prop="balance">
                                    <!-- <template slot-scope="scope">
                                    <span>{{scope.row.balance}}</span>
                                    </template> -->
                                    
                                </el-table-column>
                           
                                <el-table-column align="left" label="实际退费金额" prop="sum_diff_account">
                                    <template slot-scope="scope">
                                    <span>{{(scope.row.balance - scope.row.diff_account).toFixed(2)}}</span>
                                    </template>
                                </el-table-column>
                        
                                <el-table-column align="left" label="船名">
                                    <template slot-scope="scope">
                                    <span>{{scope.row.ship_name}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="left" label="调差金额" prop="diff_account" :disabled="opera_type !== 'ApplyAdjust'" >
                                    <template slot-scope="scope">
                                        <el-input type="number" v-model="scope.row.diff_account" :disabled="opera_type !== 'ApplyAdjust'"/>
                                    </template>                                 
                                </el-table-column>

                                <el-table-column align="left" label="查看开票记录">
                                    <template slot-scope="scope">
                                        <el-button type="primary" @click="showFinance(scope.row)" >查看开票记录</el-button>
                                    </template>
                                </el-table-column>

                                </el-table>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="业管备注">
                                <el-input type="textarea"  :rows="4" v-model="form.refuse_reason" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="财务备注">
                                <el-input type="textarea"  :rows="4" v-model="form.remark" style="width: 48%;" :disabled="opera_type !== 'ApplyAdjust'" />
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="18">
                            <el-form-item label="财务主管审核状态">
                                <el-input type="text"  :rows="4" v-model="form.finance_status_name" style="width: 48%;" disabled/>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="18">
                            <el-form-item label="财务主管备注">
                                <el-input type="textarea"  :rows="4" v-model="form.finance_remark" style="width: 48%;" disabled/>
                            </el-form-item>
                        </el-col>

                        <el-col :span="18">
                            <!-- 身份证明文件 -->
                            <el-form-item label="申请文件" prop="attachments">
                            <attachment-list 
                                object-type="member.member" :object-id="form.id" :file-list="file_list"
                                :attachment-name="attachment_name"
                                @removed="loadFileList('member.memberquitapply', form.id)"></attachment-list>
                            <el-button type="primary" size="small" @click="handleUpload" class="ml-2">上传</el-button>
                            </el-form-item>
                        </el-col>

                    </div>
                </div>
            </el-form>
            <!--创建按钮-->
            <div class="btn-box">
                <el-button type="primary" @click="handleSuccess" v-if="opera_type === 'ApplySuccess'">审核通过</el-button>
                
                <el-button type="primary" @click="handleReject" v-if="opera_type === 'ApplySuccess'">审核不通过</el-button>
                <el-button type="primary" @click="handleBusinessSuccess" v-if="opera_type === 'BusinessAuditing'">审核通过</el-button>
                <el-button type="primary" @click="handleBusinessReject" v-if="opera_type === 'BusinessAuditing'">审核不通过</el-button>
                <el-button type="primary" @click="handleUpdate" v-if="opera_type === 'ApplyAdjust' | opera_type === 'ApplyUpdate'">确认修改</el-button>
                <el-button type="primary" @click="handleRefuse" v-if="opera_type === 'ApplyAdjust'">拒绝申请</el-button>
                <el-button type="primary" @click="handleFinanceSuccess" v-if="opera_type === 'ApplyAdjust' && $perm(['member.finance_update_ship_quit_apply'])  && form.finance_status === 3">审核通过(财务主管可操作)</el-button>
                <el-button type="primary" @click="handleFinanceReject" v-if="opera_type === 'ApplyAdjust' && $perm(['member.finance_update_ship_quit_apply']) && form.finance_status === 3">审核不通过(财务主管可操作)</el-button>
                <el-button @click="() => {this.$router.go(-1)}">返回列表</el-button> 
            </div>
            </el-collapse-item>
            <el-collapse-item title="相关文书" name="2">
                        <el-col>
                            <file-sign-list :attachments="file_list" object_type="member.memberquitapply" :object_id="form.customer"></file-sign-list>
                         </el-col>
            </el-collapse-item>
            <upload-dialog ref="upload" :object-name="form.member_name" :file-type-list="file_type_list"
                object-type="member.memberquitapply" :object-id="form.id" :append-to-body="true"
                :default-issue-date.sync="default_issue_date" :ship-list="shipList" 
                @appended="handleAppended" @uploaded="loadFileList('member.memberquitapply', form.id)">
            </upload-dialog>
            <el-dialog :visible.sync="invoiceVisible" width="60%">
                <el-table :data="invoice_list" border style="width: 70%">
                    <el-table-column prop="name" label="抬头" width="180">
                    </el-table-column>
                    <el-table-column prop="invoice_date" label="日期" width="180">
                    </el-table-column>
                    <el-table-column prop="amount" label="金额" width="180">
                    </el-table-column>
                    <el-table-column prop="type" label="类型" width="180">
                    </el-table-column>
                    <el-table-column prop="creator_name" label="创建人">
                    </el-table-column>
                </el-table>

                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="InfolistVisible = false">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog :visible.sync="SuggestionVisible" width="50%">
                <el-form ref="refuse_reason" :model="refuse_reason" label-width="120px">
                <el-form-item label="备注" width="50%">
                    <el-input type="textarea"  :rows="10" v-model="refuse_reason"></el-input>
                </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="RefuseQuitShipApply" v-show="result === 2">确认拒绝</el-button>
                <el-button type="primary" @click="addMessage" v-show="result === 0">确认拒绝</el-button>
                <el-button type="primary" @click="successQuitShipApply" v-show="result === 1">确认通过</el-button>
                <el-button type="primary" @click="businessQuitShipApply" v-show="result === 5">确认通过</el-button>
                <el-button type="primary" @click="businessRefuseQuitShipApply" v-show="result === 6">确认拒绝</el-button>
                <el-button type="primary" @click="financeAddMessage" v-show="result === 4">确认拒绝</el-button>
                <el-button type="primary" @click="financeSuccessQuitShipApply" v-show="result === 3">确认通过</el-button>
                </span>
            </el-dialog>
        </el-collapse>
        </el-card>
    </div>
</template>

<script>

import {financeRejectQuitApply,financeSuccessQuitApply,financeQuitFailApply,getShipQuitApplyInfo,updateShipQuitApply,successShipQuitApply,failShipQuitApply,getShipInvoice,businessRejectQuitApply,businessSuccessQuitApply} from '@/api/member'
import UploadDialog from "@/components/UploadDialog"
import { fetchList as fetchGroupList } from "@/api/group";
import { fetchFileList } from "@/utils"
import FileSignList from '@/components/FileSignListDetail'
import { fetchFileTypeList, getObjectFileAll } from '@/api/common'
import AttachmentList from "@/components/AttachmentList"




export default {
    name: "quitShipApplyDetail",
    components: {
        UploadDialog,
        AttachmentList,
        FileSignList

    },
    computed: {
        attachment_name: function () {
        let name = this.form.ship_name
        return (name + ".zip");
        }
    },
    data() {
        return {
            ship_name:"",
            member:"",
            activeNames: ["1", "2"],
            creator:"",
            apply_time:"",
            result:null,
            default_issue_date: '',
            file_type_list: [],
            groupList: [],
            file_list: [],
            shipList:[],
            invoice_list:[],
            invoice_type_list:[
                {'id':1,'name':'未开具发票'},
                {'id':2,'name':'冲红发票'},
                {'id':3,'name':'扣税点'},
            ],
            is_member:true,
            form:{
                'id':""
            },
            apply_info:{},
            opera_type:"",
            SuggestionVisible:false,
            invoiceVisible:false,
            refuse_reason:"",
            loadingText: '正在加载数据，请稍等...',
        };
    },

    methods: { 
        showFinance(row){
            getShipInvoice({"id":row.ship_id}).then(res => {
                this.invoice_list = res
                this.invoiceVisible = true
                })
                .catch(error => {
                    this.loading = false
                    this.$message.error(error)
                })
        },
        handleUpdate(){
            let account_list = this.form.diff_account
            let count_list = []
            let update_type = 1
            account_list.forEach(item => {
                    if (item.diff_account > item.balance){
                        count_list.push(item.ship_name)
                    }
                })
            if (count_list.length > 0){
                this.$error_message("调差金额不能大于账户余额！")
                    return
            }
            if(this.opera_type === 'ApplyAdjust'){
                update_type = 1
            }
            else {
                update_type = 2
            }
            updateShipQuitApply({"id":this.id,'data':this.form,'type':update_type}).then(resp => {
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                    })
                this.$router.push({ name: 'quitShipApplyList' })  
                })
                .catch(error => {
                    this.loading = false
                    this.$message.error(error)
                })
        },
        getData(id){
            getShipQuitApplyInfo({"id":id}).then(resp => {
                this.form = resp
                this.shipList = this.form.ship_list
                this.form.diff_account.forEach(item => {
                    item.sum_diff_account = item.balance - item.diff_account
                })
                })
                .catch(error => {
                    this.loading = false
                    this.$message.error(error)
                })
            console.log(this.form)

   
        },
        handleAppended(fileList) {
            this.file_list = this.file_list.concat(fileList)
            },
        loadFileList(object_type, object_id) {
            getObjectFileAll(object_type, object_id).then(res => {
                this.file_list = res
                this.file_list.forEach(item => {
                    this.$set(item, 'checked', true)
                })
            })
            .catch(error => {
                this.$error_message(error)
            })
        },
        handleUpload() {
            this.$refs.upload.handleOpen()
            },
        businessRefuseQuitShipApply(){
            var msg = '是否拒绝该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.SuggestionVisible = false
                businessRejectQuitApply({'id':this.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '拒绝成功!'
                    })
                    this.$router.push({ name: 'quitShipApplyList' })   
                    this.refuse_reason = ""
                })
                .catch(error => {
                    this.$message.error(error)
                })
            })
        },
        RefuseQuitShipApply(){
            var msg = '是否拒绝该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.SuggestionVisible = false
                financeQuitFailApply({'id':this.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '拒绝成功!'
                    })
                    this.$router.push({ name: 'quitShipApplyList' })   
                    this.refuse_reason = ""
                })
                .catch(error => {
                    this.$message.error(error)
                })
            })
        },
        financeAddMessage(){
            var msg = '是否拒绝该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.SuggestionVisible = false
                financeRejectQuitApply({'id':this.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '拒绝成功!'
                    })
                    this.$router.push({ name: 'quitShipApplyList' })   
                    this.refuse_reason = ""
                })
                .catch(error => {
                    this.$message.error(error)
                })
            })
        },
        addMessage(){
            var msg = '是否拒绝该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.SuggestionVisible = false
                failShipQuitApply({'id':this.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '拒绝成功!'
                    })
                    this.$router.push({ name: 'quitShipApplyList' })   
                    this.refuse_reason = ""
                })
                .catch(error => {
                    this.$message.error(error)
                })
            })
        },
        handleRefuse() {
            this.SuggestionVisible = true
            this.result = 2
        },
        handleReject() {
            this.SuggestionVisible = true
            this.result = 0
        },
        handleSuccess() {
            this.SuggestionVisible = true
            this.result = 1
        },
        handleBusinessSuccess() {
            this.SuggestionVisible = true
            this.result = 5
        },
        handleBusinessReject() {
            this.SuggestionVisible = true
            this.result = 6
        },
        handleFinanceSuccess() {
            this.SuggestionVisible = true
            this.result = 3
        },
        handleFinanceReject() {
            this.SuggestionVisible = true
            this.result = 4
        },
        financeSuccessQuitShipApply() {
            var msg = '是否通过该申请？'
            this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
            }).then(() => {
                financeSuccessQuitApply({'id':this.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                this.$message({
                    type: 'success',
                    message: '通过成功!'
                })
                this.$router.push({ name: 'quitShipApplyList' }) 
                this.refuse_reason = ""
                })
                .catch(error => {
                this.$message.error(error)
                this.is_member = false
                })
            })
            },
        businessQuitShipApply() {
            var msg = '是否通过该申请？'
            this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
            }).then(() => {
                businessSuccessQuitApply({'id':this.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                this.$message({
                    type: 'success',
                    message: '通过成功!'
                })
                this.$router.push({ name: 'quitShipApplyList' }) 
                this.refuse_reason = ""
                })
                .catch(error => {
                this.$message.error(error)
                this.is_member = false
                })
            })
            },
        successQuitShipApply() {
            var msg = '是否通过该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                if(this.refuse_reason === ""){
                    this.$error_message("请填写备注！")
                    return
                }
                successShipQuitApply({'id':this.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '通过成功!'
                    })
                    this.$router.push({ name: 'quitShipApplyList' }) 
                    this.refuse_reason = ""
                })
                .catch(error => {
                    this.$message.error(error)
                    this.is_member = false
                })
            })
        },
        loadData() {
            this.getData(this.id)
            if (this.opear_type  !== 'ApplySuccess'){
                this.loadFileList('member.memberquitapply', this.id)
            }
            let p = []
            p.push(fetchFileTypeList({ file_type: "bc|sc" }))
            p.push(fetchGroupList({type:"group_apply"}))
            Promise.all(p)
                .then(res => {
 
                this.file_type_list = res[0]
                this.groupList  =res[1]

                })
                .catch(error => {
                this.loading = false
                this.$message.error(error)
                })
                },
        
     
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'quitShipApplyList') {
            window.localStorage.removeItem('query')
        }
        next()
    },
    created() {
        this.opera_type = this.$route.query.type
        console.log(this.opera_type)
        this.id = this.$route.query.id
        
       
        this.loadData()
        // console.log(this.id )
    },
};
</script>

